// 我的收藏-收藏列表接口
import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
export function getCollectArcticleList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/favorites',
        method: 'get',
        params: {
            page: params.page,
            per: params.per,
            type: params.type
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-我的关注接口
export function getConcernsList(params, id) {
    var sign = getRequest(params);
    return request({
        url: `/v4/users/${id}/follows`,
        method: 'get',
        params: {
            page: params.page,
            per: params.per,
            follow_type: params.follow_type
        },
        headers: {
            'X-Signature': sign
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/collect.js